import React from "react";
import { useForm, useWatch } from "react-hook-form";

// Feature controllers keep serialization and async recovery; RHF owns drafts.
export default function useEditorForm(defaultValues) {
  const form = useForm({
    defaultValues: { draft: defaultValues },
    mode: "onChange",
  });
  const values = useWatch({ control: form.control, name: "draft" });
  const { getValues, setValue } = form;
  const setValues = React.useCallback(
    (next) => {
      const updated =
        typeof next === "function" ? next(getValues("draft")) : next;
      setValue("draft", updated, { shouldDirty: true, shouldValidate: true });
    },
    [getValues, setValue],
  );
  return [values, setValues, form];
}
